module.exports = __webpack_public_path__ + "d8983140f8623af0d6a739386c9d01e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgnw_g.png
// module id = 299
// module chunks = 3